<ng-template #risklineTravelSearchModalForm let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Travel Search</h5>
    <button type="button" class="btn-close" (click)="cancelForm()" aria-label="Close"></button>
  </div>

  <div class="modal-body">
    <form [formGroup]="searchForm" (ngSubmit)="submitForm()">
      <div class="row g-2">
        <div class="col-md-6">
          <label class="form-label">Origin (ISO) <span class="text-danger">*</span></label>
          <input type="text" class="form-control" formControlName="origin"
                 [class.is-invalid]="formSubmitted && form['origin'].errors" />
        </div>
        <div class="col-md-6">
          <label class="form-label">Destination (ISO) <span class="text-danger">*</span></label>
          <input type="text" class="form-control" formControlName="destination"
                 [class.is-invalid]="formSubmitted && form['destination'].errors" />
        </div>
        <div class="col-md-4">
          <label class="form-label">Nationality (ISO)</label>
          <input type="text" class="form-control" formControlName="nationality" />
        </div>
        <div class="col-md-4">
          <label class="form-label">From <span class="text-danger">*</span></label>
          <input type="date" class="form-control" formControlName="fromDate"
                 [class.is-invalid]="formSubmitted && form['fromDate'].errors" />
        </div>
        <div class="col-md-4">
          <label class="form-label">To <span class="text-danger">*</span></label>
          <input type="date" class="form-control" formControlName="toDate"
                 [class.is-invalid]="formSubmitted && form['toDate'].errors" />
        </div>
      </div>

      @if (validationError) {
        <div class="alert alert-warning mt-3 mb-0">{{ validationError }}</div>
      }

      <div class="text-end mt-3">
        <button type="submit" class="btn btn-info" [disabled]="isLoading">
          @if (isLoading) { <span class="spinner-border spinner-border-sm me-1"></span> }
          Search
        </button>
      </div>
    </form>

    @if (result) {
      <hr />

      <h5>{{ result.trip_risk_level.name }}</h5>
      <span class="badge fs-13 rounded-pill" [ngStyle]="riskBadgeStyle(result.trip_risk_level.id)">{{ result.trip_risk_level.name }} - {{ result.trip_risk_level.id }}</span>
      <p class="mt-2">{{ result.trip_risk_level.description }}</p>

      <h6 class="mt-3">Entry &amp; Borders</h6>
      <p>{{ result.entry_borders.status }}</p>
      <div [innerHTML]="trustHtml(result.entry_borders.text)"></div>

      <h6 class="mt-3">Visa</h6>
      <p>{{ result.travel_documentation?.visa_checker?.is_visa_required }}</p>
    }
  </div>

  <div class="px-3 pb-2">
    <app-riskline-attribution [hideCredit]="true"></app-riskline-attribution>
  </div>

  <div class="modal-footer justify-content-between">
    <app-riskline-attribution [hideDisclaimer]="true"></app-riskline-attribution>
    <button type="button" class="btn btn-light" (click)="cancelForm()">Close</button>
  </div>
</ng-template>
